export function updateCount(itemQueue, countQueue, timeInQueue){
  return {
    type : itemQueue,
    count : countQueue,
    time: timeInQueue
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_queue_count.js